module.exports = __webpack_public_path__ + "img/pdf.55d55a3d.png";